type MutableHeaders = Record<string, unknown> & {
	delete?: (name: string) => void;
};

export function shouldLetBrowserSetMultipartBoundary(data: unknown): boolean {
	return typeof FormData !== "undefined" && data instanceof FormData;
}

export function stripContentTypeHeader(headers: MutableHeaders | undefined): void {
	if (!headers) {
		return;
	}

	if (typeof headers.delete === "function") {
		headers.delete("Content-Type");
		headers.delete("content-type");
		return;
	}

	delete headers["Content-Type"];
	delete headers["content-type"];
}
